import React, { useContext, useEffect, useRef, useState } from "react"; 
import { Context } from "../contexts/AppContext";
import Icons from "../Icons/index";
import { faVideo, faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getData } from "../../lib/utils";

function VideoPlayerP({ updateGalleryData }) {
  const [galleryName, setGalleryName] = useState("");
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState("00:00:00");

  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [imageSrc, setImageSrc] = useState(null);
  const [showOverlay, setShowOverlay] = useState(true); // 👈 overlay state

  useEffect(() => {
    const fetchVideoThumb = async () => {
      try {
        if (!appState?.currentDBVideoId) return;
        const json = await getData(`videos/videoThumb/${appState.currentDBVideoId}`);
        if (json?.thumbnail) {
          setImageSrc(`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${json.thumbnail}`);
        }
      } catch (err) {
        console.error("Error fetching video thumb:", err);
      }
    };
    fetchVideoThumb();
  }, [appState?.currentDBVideoId]);

  const onCloseHandler = () => {
    setAppState((prevState) => ({
      ...prevState,
      modalData: { ...prevState.modalData, type: null, isOpen: false },
    })); 
  };

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const day = date.getDate();
    const month = date.toLocaleString("en-GB", { month: "short" });
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";
    return `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
  };

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600); 
    const mins = Math.floor((seconds % 3600) / 60);  
    const secs = Math.floor(seconds % 60);  
    return [hrs, mins, secs].map(v => v.toString().padStart(2,"0")).join(":");
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const updateTime = () => setCurrentTime(formatTime(video.currentTime));
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, []);

  const lists = [
    { id: "general", title: "GENERAL", icon: <FontAwesomeIcon icon={faVideo} />, event: "VideoGeneralSetting" },
    { id: "advance", title: "ADVANCE", icon: <FontAwesomeIcon icon={faGear} />, event: "VideoAdvanceSetting" }
  ];

  let [temp, setTemp] = useState("VideoGeneralSetting");
  let ActTypeComponent = Icons[temp];
  const [selected, setSelected] = useState("general");

  const handleColor = (row) => {
    setSelected(row.id);
    setTemp(row.event);
    ActTypeComponent = Icons[temp];
  };

  return (
    <>
      <div className="flex justify-between">
        <div>
          <div className="font-bold text-2xl">{appState?.videoArr[appState.currentVideoId]?.title}</div>
          <div className="font-bold text-2xl">{formatDate(appState?.videoArr[appState.currentVideoId]?.createdAt)}</div>
        </div>
        <div className="flex gap-8">
        <div className="font-bold text-xl">Views: {appState?.videoArr[appState.currentVideoId]?.views}</div>
        <button onClick={onCloseHandler} className="bg-gray-800 text-white h-10 px-4">Close X</button>
        </div>
      </div>

      <div className="flex gap-4 mt-2 relative">
        {/* Video + Image Container */}
        <div className="relative w-[830px] h-[466px] overflow-hidden">
          {/* Video */}
          <video
            ref={videoRef}
            crossOrigin="anonymous"
             
            loop
            controls
            
            className="w-full h-full object-cover"
          >
            <source
              src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState?.videoArr[appState.currentVideoId]?.url}`}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>

          {/* Overlay Image */}
          {imageSrc && showOverlay && (
            <img
              src={imageSrc}
              alt="overlay"
              className="absolute top-0 left-0 w-full h-full object-cover pointer-events-none"
            />
          )}

          {/* Play Icon Overlay */}
          {imageSrc && showOverlay && (
            <div
              className="absolute top-0 right-0 left-0 bottom-0 flex items-center justify-center cursor-pointer"
              onClick={() => {
                videoRef.current.play();  // play video
                setShowOverlay(false);    // hide overlay
              }}
            >
              <div className="text-4xl text-white opacity-60 center-play-ico">
                <img
                  alt="play"
                  loading="lazy"
                  className="w-20 h-20"
                  src="../../../img/video_icon.svg"
                />
              </div>
            </div>
          )}
        </div>

        {/* Right side panel */}
        <div className="w-[300px] h-[100vh] bg-[#cccccc] py-2">
          <div className="w-full flex justify-around -mt-2">
            {lists.map((list) => (
              <div
                key={list.id}
                onClick={() => handleColor(list)}
                className={`border w-full gap-2 flex align-center items-center justify-center ${
                  list.id === selected
                    ? "bg-slate-400 text-white"
                    : "bg-gray-100 border-gray-200 text-gray-600"
                }`}
              >
                {list.icon} {list.title}
              </div>
            ))}
          </div>
          <ActTypeComponent currentTime={currentTime} videoRef={videoRef} />
        </div>
      </div>
    </>
  );
}

export default VideoPlayerP;
